import { render, staticRenderFns } from "./BaseEntityBadge.vue?vue&type=template&id=05212b49"
import script from "./BaseEntityBadge.vue?vue&type=script&lang=js"
export * from "./BaseEntityBadge.vue?vue&type=script&lang=js"
import style0 from "./BaseEntityBadge.vue?vue&type=style&index=0&id=05212b49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports